<template>
  <a-layout id="components-layout-custom-trigger">
    <a-layout-sider v-model="collapsed" :trigger="null" collapsible>
      <div class="logo" @click="$router.push('/')">{{ collapsed ? 'LINSY' : 'LINSY HOME' }}</div>
      <div class="search-menu">
        <a-input ref="search-input" v-if="!collapsed" v-model="filterMenuKeyword" allow-clear placeholder="搜菜单">
          <a-icon slot="prefix" type="search"/>
        </a-input>
        <div class="search-icon" @click="searchIconClick" v-else>
          <a-icon type="search"/>
        </div>
      </div>
      <aside-menu class="aside-menu" :collapsed="collapsed"/>
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="layout-header">
        <div class="control-area">
          <a-icon
            class="trigger"
            :type="collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="collapsed = !collapsed"
          />
        </div>
        <a-space :size="20" class="user-area">
          <div class="it-bing-btn" @click="onJumpToItBing">
            <svg-icon iconClass="it-bing" className="it-bing-icon"></svg-icon>
            <span>IT必应</span>
          </div>
          <div>
            <a-dropdown :trigger="['click']">
              <a-icon type="user" class="user-icon"></a-icon>
              <a-menu slot="overlay" style="width: 100px">
                <a-menu-item key="1">
                  <a @click="logout">退出</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <span>你好,{{ userInfo.nickName }}</span>
          </div>
        </a-space>
      </a-layout-header>
      <a-layout-content :style="{ margin: '5px 16px', background: '#fff' }">
        <div class="route-tabs flex">
          <a-tabs class="tab-items" v-model="currentPath" hide-add type="editable-card" @tabClick="tabClick"
                  @edit="onEdit">
            <a-tab-pane v-for="item in cachedRoutes" :key="item.fullPath" :closable="!(item.meta && item.meta.fixedTab)"
                        :tab="getPageTitle(item)"/>
          </a-tabs>
          <div class="tab-handle">
            <a-dropdown v-model="tabHandleVisible">
              <a-button icon="unordered-list" style="height: 40px"></a-button>
              <a-menu slot="overlay" @click="tabHandleClick" style="user-select: none">
                <a-menu-item key="1">
                  关闭当前
                </a-menu-item>
                <a-menu-item key="2">
                  关闭其他
                </a-menu-item>
                <a-menu-item key="3">
                  关闭所有
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
        <div class="layout-scroll-area" :style="scrollAreaStyle">
          <keep-alive :include="cachedList">
            <router-view :key="$route.fullPath"/>
          </keep-alive>
        </div>
      </a-layout-content>
    </a-layout>
    <!-- 小林AI入口 -->
    <AiRobotEntry></AiRobotEntry>
  </a-layout>
</template>
<script>
import AiRobotEntry from '@/components/LinAi/ai-robot-entry.vue'
import debounce from 'lodash/debounce';
import {mapState} from 'vuex';
import {resetState} from "@/store";
import AsideMenu from '@/components/AsideMenu/AsideMenu'
import Bus from '@/utils/bus'

export default {
  components: {AsideMenu, AiRobotEntry},
  provide() {
    return {
      getCollapsed: () => this.collapsed
    }
  },
  data() {
    return {
      tabHandleVisible: false,
      collapsed: false,
      filterMenuKeyword: '',
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user?.userInfo,
      cachedRoutes: state => state?.app?.cachedRoutes || []
    }),
    currentPath: {
      get() {
        return this.$store.state.app.currentPath
      },
      set(value) {
        this.$store.commit('app/setCurrentPath', value)
      }
    },
    cachedList() {
      return [...this.cachedRoutes.length ? this.cachedRoutes.filter(item => !(item.meta && item.meta.notCache)).map(item => item.name) : []]
    },
    scrollAreaStyle() {
      let customStyle = this.$route.meta?.layoutStyle || {}

      return {
        padding: '15px',
        height: 'calc(100vh - 114px)',
        overflow: 'auto',
        ...customStyle
      }
    }
  },
  created() {
    Bus.$on('close-tab', (targetKey) => {
      this.onEdit(targetKey)
    })
  },
  mounted() {
    const dom = document.body.querySelector('.user-area')
    const chatbot = document.body.querySelector('#dify-chatbot-bubble-button')
    const { width } = dom ? dom.getBoundingClientRect() : {}
    if (!chatbot) return;
    if (width) {
      chatbot.style.right = `${width + 15}px`
      chatbot.style.top = '7px'
    }
    chatbot.style.display = 'block'
  },
  watch: {
    filterMenuKeyword: debounce(function (val) {
      this.$store.commit('app/setFilterMenuKeyword', val)
    }, 100),
  },
  methods: {
    getPageTitle(routeItem) {
      let { meta: { title, titleKey } } = routeItem

      if (typeof title === 'function') {
        return title(routeItem)
      } else if (titleKey) {
        let name = routeItem.query[titleKey] || '';
        if (name) {
          name = `(${name.length > 5 ? name.substr(0, 5) + '...' : name})`
        }

        return title + name
      } else {
        return title
      }
    },
    searchIconClick() {
      this.collapsed = false
      setTimeout(() => {
        this.$refs['search-input'].$el.querySelector('.ant-input').focus()
      }, 200)
    },
    tabClick(key) {
      if (this.$route.path !== key) {
        this.$router.push(key)
      }
    },
    onEdit(targetKey) {
      // action === remove
      let activeKey = this.currentPath
      let lastIndex;
      this.cachedRoutes.forEach((route, i) => {
        if (route.fullPath === targetKey) {
          lastIndex = i - 1;
        }
      });
      const routes = this.cachedRoutes.filter(route => route.fullPath !== targetKey);
      if (routes.length && activeKey === targetKey) {
        if (lastIndex >= 0) {
          activeKey = routes[lastIndex].fullPath;
        } else {
          activeKey = routes[0].fullPath;
        }
      }
      if (!routes.length) {
        activeKey = '/index'
      }
      this.$store.commit('app/removeCachedRoute', {fullPath: targetKey})
      this.$store.commit('app/setCurrentPath', activeKey)
      if (activeKey && activeKey !== this.$route.fullPath) {
        this.$router.push(activeKey)
      }
    },
    logout() {
      this.$axios.get(`/${process.env.VUE_APP_PROXY_SSO_API}/sso/auth/logout`).then(() => {
        resetState()
        const redirectUrl = window.location.origin
        window.location.replace(`${process.env.VUE_APP_SSO_LOGIN_PAGE}?redirectUrl=${redirectUrl}`)
      })
    },
    onJumpToItBing() {
      let url = `${process.env.VUE_APP_PORTAL_URL}/DemandManagement/home`

      window.open(url, "_blank");
    },
    tabHandleClick: debounce(function (e) {
      const fullPath = this.$route.fullPath
      const cachedRoutes = this.$store.state.app.cachedRoutes
      if (e.key === '1') {
        // 关闭当前
        if (fullPath !== '/index') {
          this.onEdit(fullPath)
        }
      } else if (e.key === '2') {
        // 关闭其他
        const others = cachedRoutes.filter(r => {
          return r.fullPath !== '/index' && r.fullPath !== fullPath
        })
        others.forEach(r => {
          this.onEdit(r.fullPath)
        })
      } else {
        // 关闭所有
        cachedRoutes.concat(this.$route).forEach(r => {
          if(r.fullPath !== '/index') {
            this.onEdit(r.fullPath)
          }
        })
      }
    }, 100)
  }
}
</script>
<style scoped lang="stylus">
#components-layout-custom-trigger {
  height 100vh

  .search-menu {
    height 36px
    margin 0 20px

    .search-icon {
      text-align center
      font-size 18px
      color #fff
      cursor pointer
    }

    /deep/ .ant-input-prefix {
      color #fff
    }

    /deep/ .ant-input {
      background-color: transparent;
      color: #fff;
      border: none;
      border-bottom: 1px solid rgba(255, 255, 255, .3);
      box-shadow: none;
      font-size: 13px;
      border-radius: 0;

      &::-webkit-input-placeholder {
        color rgba(255, 255, 255, .4)
      }
    }

    /deep/ .ant-input-clear-icon {
      color #fff
    }
  }

  .layout-header {
    background-color #fff
    display flex
    justify-content space-between
    align-items center
    padding 0
  }

  .trigger {
    font-size: 18px;
    padding: 0 12px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #00bfbf;
    }
  }

  .logo {
    font-size 18px
    line-height 32px
    font-weight bold
    text-align center
    color #00bfbf
    height: 32px;
    cursor pointer;
    margin: 14px;
    white-space nowrap
    overflow hidden
  }

  .aside-menu {
    height calc(100vh - 100px)
    overflow auto

    &::-webkit-scrollbar-track {
      background #001529
    }

    &::-webkit-scrollbar {
      height 2px
      width 0
    }

    &::-webkit-scrollbar-thumb {
      border none
      outline none
    }
  }

  .control-area {
    padding 0 12px
    display: flex
    align-items: center
  }

  .user-area {
    padding-right: 24px;
  }

  .user-icon {
    font-size: 18px;
    cursor: pointer;
    margin-right: 5px;

    &:hover {
      color: #00bfbf;
    }
  }

  .it-bing-btn {
    padding: 0 10px;
    height: 32px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    border: 1px solid #00bfbf;
    background-color: rgba(0, 191, 191, 0.15);
    border-radius: 4px;
    transition: all ease 0.2s;

    &:hover {
      color: #fff;
      background-color: #00bfbf;

      .it-bing-icon {
        color: #fff;
      }
    }

    .it-bing-icon {
      color: #00bfbf;
      font-size: 17px;
      outline: none;
      margin-right: 4px
    }
  }
}

.route-tabs {
  background: #f0f2f5;
  user-select none

  .tab-items {
    flex 1 0 auto
    width calc(100% - 50px)
  }

  .tab-handle {
    flex 0 1 32px
  }

  /deep/ .ant-tabs-bar {
    margin-bottom 0
  }

  /deep/ .ant-tabs-tab:not(.ant-tabs-tab-active)>div {
    transform scale(1)
    transition all .3s
    &:active {
      transform scale(0.9)
      transform-origin bottom center
    }
  }
}
</style>
